// src/components/SGloopMainCard.js
import { useEffect, useState } from "react";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { firebaseApp } from "../../firebase";

export default function SGloopMainCard({ id }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
const db = getFirestore(firebaseApp);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const ref = doc(db, "oneSG", id);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setData(snap.data());
        } else {
          console.warn("No document found for ID:", id);
        }
      } catch (err) {
        console.error("Error fetching SG data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div className="p-4 bg-white rounded-xl shadow-md text-center">
        <p className="text-gray-500 text-sm">Loading...</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="p-4 bg-white rounded-xl shadow-md text-center">
        <p className="text-red-500 text-sm">No data found</p>
      </div>
    );
  }

  return (
    <div className="p-6 bg-white rounded-2xl shadow-md space-y-3">
      {/* Name */}
      <h2 className="text-base font-bold text-gray-800">{data.areaName}</h2>

      {/* Number of pax */}
      <p className="text-gray-600 text-sm">
        <span className="font-medium">{data?.memberSubscription?.length>0 ? data.memberSubscription.length : 0}</span> members inside
      </p>

      {/* Upcoming events */}
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-gray-700">Upcoming Events</h3>
        <ul className="list-disc list-inside text-gray-600 text-sm space-y-1">
          {data.upcomingEvents?.slice(0, 3).map((event, i) => (
            <li key={i}>{event}</li>
          )) || <li>No upcoming events</li>}
        </ul>
      </div>
    </div>
  );
}
